import { useState } from 'react'
import Images from '../../../../common/Images'
import './Expandable.css'
import { BiLinkExternal } from 'react-icons/bi'

interface IProps {
  title: string
  link: string
}

function Expandable (props: IProps) {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className={`expandable ${isExpanded ? 'expanded' : ''}`}>
      <div
        className="expandable-title"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span>{props.title}</span>
        <span className="expandable-title-icons">
          {isExpanded && (
            <a className="open-link-icon" href={props.link}>
              <BiLinkExternal size={30} color="white" />
            </a>
          )}
          <img srcSet={Images.HeaderArrowDown} alt="" />
        </span>
      </div>
      <div className="expandable-frame">
        <embed src={props.link} type="application/pdf"></embed>
      </div>
    </div>
  )
}

export default Expandable
